const API_BASE_URL = 'https://api.hiringsupportaf.in/api';

export const API_ENDPOINTS = {
  // Cities
  GET_CITIES: `${API_BASE_URL}/cities`,
  ADD_CITY: `${API_BASE_URL}/cities`,
  
  // Centers
  GET_CENTERS_BY_CITY: (cityId) => `${API_BASE_URL}/centers/city/${cityId}`,
  ADD_CENTER: `${API_BASE_URL}/centers`,
  
  // Courses
  GET_COURSES_BY_CENTER: (centerId) => `${API_BASE_URL}/courses/center/${centerId}`,
  ADD_COURSE: `${API_BASE_URL}/courses`,
  
  // Resumes
  GET_RESUMES: `${API_BASE_URL}/resumes`,
  UPLOAD_RESUME: `${API_BASE_URL}/resumes/upload`,
  DOWNLOAD_RESUME: (candidateId) => `${API_BASE_URL}/resumes/download/${candidateId}`,
  DELETE_RESUME: (candidateId) => `${API_BASE_URL}/resumes/${candidateId}`,
  
  // Remarks
  GET_REMARKS: (candidateId) => `${API_BASE_URL}/remarks/${candidateId}`,
  ADD_REMARK: `${API_BASE_URL}/remarks`,

  // Users
  GET_USERS: `${API_BASE_URL}/users`,
  ADD_USER: `${API_BASE_URL}/users/add`,
  LOGIN: `${API_BASE_URL}/users/login`,
  DELETE_USER: (userId) => `${API_BASE_URL}/users/${userId}`, 
  
 // Vacancies
 GET_VACANCIES: `${API_BASE_URL}/vacancies`,
 ADD_VACANCY: `${API_BASE_URL}/vacancies`,
 VACANCY_STATUS: `${API_BASE_URL}/vacancies`,
 DELETE_VACANCY: `${API_BASE_URL}/vacancies`
};
